var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarplLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.33,
    height: 40.445,
    viewBox: "0 0 91.33 18.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;}.a,.b,.c,.d{stroke-miterlimit:10;}.a,.c{stroke-width:1.305px;}.b,.c,.d{fill:#fbcc8e;stroke:#fbcc8e;}.b{stroke-width:0.979px;}.d{stroke-linecap:round;stroke-width:2.61px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.047 -161.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.699 162.886)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.932,178.313a5.281,5.281,0,0,1-1.233-3.869V168.98a5.352,5.352,0,0,1,1.221-3.906,5.2,5.2,0,0,1,3.858-1.2h2.9a5.1,5.1,0,0,1,3.33.923,4.016,4.016,0,0,1,1.246,2.935.654.654,0,0,1-.144.562.754.754,0,0,1-.575.2q-.648,0-.767-.743a2.433,2.433,0,0,0-.791-1.88,3.94,3.94,0,0,0-2.3-.515h-2.9a5.176,5.176,0,0,0-2.145.324,2.106,2.106,0,0,0-1.114,1.126,5.637,5.637,0,0,0-.335,2.168v5.463a5.379,5.379,0,0,0,.347,2.143,2.158,2.158,0,0,0,1.126,1.127,5.387,5.387,0,0,0,2.144.348h2.875a3.954,3.954,0,0,0,2.3-.515,2.433,2.433,0,0,0,.791-1.881A.939.939,0,0,1,96,175.1a.733.733,0,0,1,.539-.18.759.759,0,0,1,.575.2.66.66,0,0,1,.144.564,4.02,4.02,0,0,1-1.246,2.935,5.1,5.1,0,0,1-3.33.922H89.8A5.281,5.281,0,0,1,85.932,178.313Z",
    transform: "translate(-84.699 -163.877)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.006 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.44,179a.746.746,0,0,1-.36.6.724.724,0,0,1-.431.12.745.745,0,0,1-.6-.359l-3.833-6.23h-4.1V178.8a.742.742,0,1,1-1.484,0V164.62a.656.656,0,0,1,.742-.742h5.606a3.807,3.807,0,0,1,4.265,4.265v.718a4.541,4.541,0,0,1-.851,2.911,3.637,3.637,0,0,1-2.48,1.282l3.4,5.51A.736.736,0,0,1,184.44,179Zm-9.321-7.355h4.864a2.386,2.386,0,0,0,2.779-2.78v-.718a2.385,2.385,0,0,0-2.779-2.78h-4.864Z",
    transform: "translate(-173.634 -163.878)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.027 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M225.547,164.955a4.294,4.294,0,0,1,1.09,3.187v.718a3.822,3.822,0,0,1-4.265,4.265h-4.864V178.8a.742.742,0,1,1-1.485,0V164.62a.656.656,0,0,1,.742-.742h5.606A4.332,4.332,0,0,1,225.547,164.955Zm-.4,3.187a2.384,2.384,0,0,0-2.779-2.78h-4.864v6.278h4.864a2.386,2.386,0,0,0,2.779-2.78Z",
    transform: "translate(-216.023 -163.878)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.73 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M255.62,178.8V164.62a.742.742,0,0,1,1.485,0v13.443h7.068a.742.742,0,1,1,0,1.485h-7.81A.656.656,0,0,1,255.62,178.8Z",
    transform: "translate(-255.62 -163.878)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(107.448 167.015)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(103.543 162.936)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(117.49 162.069)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(116.247 175.805)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.62,
    cy: 1.62,
    r: 1.62,
    transform: "translate(103.623 175.546)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    y1: 4.541,
    x2: 9.695,
    transform: "translate(109.068 164.093)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x2: 12.488,
    y2: 13.157,
    transform: "translate(105.351 164.953)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.635 161.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M140.421,176.614l-5.894-14.039a.766.766,0,0,0-.791-.575h-.072a.847.847,0,0,0-.839.575l-5.846,14.039a1.171,1.171,0,0,0-.072.359.677.677,0,0,0,.456.623,1.016,1.016,0,0,0,.359.071.651.651,0,0,0,.623-.479l1.485-3.569.6-1.486,3.234-7.786,3.258,7.786.623,1.486,1.509,3.569a.68.68,0,0,0,.623.479.9.9,0,0,0,.359-.071.676.676,0,0,0,.455-.623A1.165,1.165,0,0,0,140.421,176.614Z",
    transform: "translate(-126.907 -161.999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarplLogo);
export default __webpack_public_path__ + "static/media/carpl_logo.0b1dea0d32f8725d8b27aaac409679d2.svg";
export { ForwardRef as ReactComponent };